// 試卷大 modal（exam-exam-manage「新增試卷／修改試卷」＝legacy `#dialogModal`）
// ＋題組維護 modal（`#examGroupModal`）＋隨機產生題目／從題庫選擇 modal（`#produceQuestionDiv`）
// ＋自動配分 prompt（common.prompt 鏡像）。批次 13（B3-1，Gitea issue #8）。
//
// legacy 流程（行號逐檔 grep -n 親驗 2026-09-23；詳 docs/plans/2026-09-23-batch13-exam-modal-progress.md §1.1）：
//   - showModal(id)（examManage.jsp:365-413）：新增＝欄位預設（isLimitedTime=0/level=0/reviewTest=1/
//     testingTime=0/remindTime=0/totalScore=0/passingScore=0/sort=0/effectiveDate=''；
//     isEnable1 checked 在 HTML 無此欄位＝no-op★legacy-known-issue 照實不畫）；修改＝回填＋
//     getExamGroupList()＋org/jobType **disabled**（departmentId 不鎖）。
//   - isLimitedTime change（:225-233）：值 1→testingTime/remindTime disabled＋**值清 0**（兩個分支都清 0）；
//     值 0→enabled＋值清 0。
//   - dialogModal hide 守衛（:237-243）：passingScore>totalScore →
//     showAlertDialog『及格分數大於總分，請修正。』（:240）＋return false（**不關閉**）。
//   - save(isSave)（:415-466）驗證鏉（順序固定）：`#inputForm` valid（jquery validate inline
//     必填欄位）→ jobType<=0『訓練類別未填寫』(:419)→ dept<=0『部門未填寫』(:422)→
//     passingScore>totalScore『存檔失敗，及格分數大於總分，請修正。』(:426)→ isLimitedTime==0
//     （限制作答時間）且 testingTime<=0『考試時間須大於0』(:430)→ POST saveExamAjax →
//     成功：doQuery(:439)＋exam=response.data(:440)＋id 回填(:441)＋title 換『修改試卷』(:442)＋
//     org/jobType disabled(:446-447)＋
//     isSave 時 info(:444)＋modal hide(:458)；**isSave=false 且 exam!=null 時不 POST**
//     （:433 `if (isSave || exam == null)`）——showGroupModal/showGenModal 的 save(false) 在
//     修改模式只驗證。
//   - showGroupModal(id)（:576-604）：先 save(false)（不過驗證就中止 :580）；新增 totalScore/qty
//     顯示 0（:586-587）；
//     修改 getExamGroupAjax 回填（:589-595）＋getExamDetailList（:600）。
//   - saveGroup(isSave)（:606-674）：groupForm valid→examId→detailArray→saveExamGroupAjax→
//     inputForm totalScore(:640)＋getExamGroupList(:664)；**總分<及格 且 isSave**（:642-644）→
//     sysConfirm『目前總分低於及格分數，是否由系統自動調整及格分數?』(:644)→確定 updateExamAjax
//     (passingScore 同步 :652-653；info(suctext) 在 success 判斷外 :655＝內層失敗也顯示）／
//     取消 info(:659 desc＋' 試卷存檔時，請記得修改及格分數。')；
//     總分>=及格時**無 info**（legacy 靜默）；isSave→關 modal。
//   - delExamGroup（:676-691）／delQuestion（:793-808）：sysConfirm『是否確定要刪除?』。
//   - showGenModal（:714-732）：先 saveGroup(false)；examType 2→『隨機出題』(:722) 藏 qSelectDiv、
//     其他→『從題庫選擇』(:726)。
//   - getQuestion（:814-846）：僅 examType=='1'（qBankId change :324-328／qlevel click :330-334）→
//     getQuestionListAjax（level1/5/10）→ qSelectTable＋rows_selected=全部 id（預設全勾）。
//   - saveExamDetail（:734-791）：produceQuestionForm valid（randomSize required 僅隨機模式；
//     select 模式該欄在隱藏 div 內＝jquery validate 忽略 hidden）→ isRandom=(examType=='2')→
//     randomSize(null→0)→qBankId→examId→examGroup.id→level1/5/10→rows_selected **有勾者**→
//     saveExamDetailAjax→doQuery(:777)＋getExamDetailList(:778)＋getExamGroupList(:779)＋info(:780)；
//     always 關 modal（:787-788）。
//   - autoScoreSet（:848-896）：common.prompt『配分總分』＋配分方法 radio3；『分數不可空白』(:863)；
//     0：avg=floor(t*100/n)/100，t≠avg*n→『自動配分需要能整除』(:871)；1/2：remainder=t%n、
//     avg=(t-remainder)/n——**`.0`/`.末` 是 class selector、score input 沒有該 class→餘數實際
//     沒套上★legacy-known-issue 照實不修**。
//
// 雛形資料策略（照 ClassEditModal／批次 10 AccountV2DialogModal 先例）：
//   - 試卷主表單存檔走 `dataSource.create/update('exam-exam-manage',…)`；題組/題目存**列上**
//     （row.examGroups，course-clazz-list 子清單先例），寫回 update op；題數欄（score 鍵）同步。
//   - 真呼叫 DataSource 的按鈕才帶 data-effect（C5-j）。
//   - 題庫下拉＝`dataSource.list('exam-question-bank')`（getQuestionBankListAjax by jobTypeId 的
//     鏡像簡化：雛形以全清單平列不過濾 jobType【雛形值待實機校準】）；題目池＝resource-rules
//     EXAM_QUESTION_POOL（每題庫 3 題）【雛形值待實機校準】。
//   - ajax 級聯（org→jobType→dept）→種子池平列（批次 11 同款簡化）【雛形值待實機校準】；
//     生效日 datepicker→文字輸入【雛形值待實機校準】；預覽（testPreview :898-902，開新頁
//     previewTesting）→提示呈現（B1-3 模式，不帶 data-effect）。
//   - 隨機出題的亂數在後端；雛形禁 Math.random → 取過濾後題池**前 N 筆**【雛形值待實機校準】。
//   - 新題組/新明細的 id：雛形本地編號 eg-9xxx／egd-9xxx（legacy 由 server 編）【雛形值待實機校準】。
//
// 【證據等級】§7 第 3 級（原始碼）。

import { useState, type ReactElement } from 'react';
import { Button } from '@/components/base/Button';
import { Checkbox } from '@/components/base/Checkbox';
import { Radio } from '@/components/base/Radio';
import { Select } from '@/components/base/Select';
import { Table, type TableColumn, type TableRow } from '@/components/base/Table';
import { Textarea } from '@/components/base/Textarea';
import { TextInput } from '@/components/base/TextInput';
import { ModalFrame, useDialogs } from '@/components/layouts';
import { t } from '@/messages/zh-TW';
import { MockDataError, resolveLegacyMessage, useDataSource } from '@/mocks';
import {
  ACCOUNT_DEPARTMENT_OPTIONS,
  ACCOUNT_JOB_TYPE_OPTIONS,
  ACCOUNT_ORGANIZATION_OPTIONS,
  EXAM_QUESTION_POOL,
  type ExamGroup,
  type ExamGroupDetail,
  type ExamQuestionPoolEntry,
} from '@/mocks/resource-rules';
import type { Row } from '@/mocks/types';
import { toUiKey } from '@/pages/templates/shared';

export interface ExamEditModalProps {
  readonly pageId: string;
  /** 'create'＝新增（showModal(0)）；'edit'＝修改（試卷名稱連結 .showEdit）。 */
  readonly mode: 'create' | 'edit';
  /** 修改時的列（examGroups 子清單掛在列上）。 */
  readonly row: Row | null;
  readonly onClose: () => void;
  readonly onClosed: () => void;
}

/** jquery.validate 全域訊息（decorator.jsp:262）。 */
const REQUIRED_TEXT = '必填欄位';

/** 難易度（QuestionDifficulty.java:4-7：UNLIMITED(0,不限)/EASY(1,易)/MODERATE(5,中)/HARD(10,難)）。 */
const EXAM_LEVEL_OPTIONS: readonly { value: string; label: string }[] = [
  { value: '0', label: '不限' },
  { value: '1', label: '易' },
  { value: '5', label: '中' },
  { value: '10', label: '難' },
];

/** 題型（QuestionType.java:4-8；questionTable 題型欄映射 q_columns，examManage.jsp:86-115）。 */
const EXAM_QUESTION_TYPE_TEXT: Readonly<Record<string, string>> = {
  '1': '是非題',
  '2': '單選題',
  '3': '多選題',
  '4': '問答題',
  '5': '臨床技能測驗題',
};

/** 出題方式（examManage.jsp:1250-1256）。 */
const EXAM_EXAM_TYPE_OPTIONS: readonly { value: string; label: string }[] = [
  { value: '1', label: '從題庫選題' },
  { value: '2', label: '隨機出題' },
];

/** 難易度顯示（examManage.jsp:128-140：EASY→易、MODERATE→中、其他→難）。 */
const examDifficultyText = (level: string): string => {
  if (level === '1') return '易';
  if (level === '5') return '中';
  return '難';
};

const groupQtyOf = (group: ExamGroup): number => group.details.length;
const groupTotalOf = (group: ExamGroup): number =>
  group.details.reduce((sum, detail) => sum + (Number.parseFloat(detail.score) || 0), 0);
const examQtyOf = (groups: readonly ExamGroup[]): number =>
  groups.reduce((sum, group) => sum + groupQtyOf(group), 0);
const examTotalOf = (groups: readonly ExamGroup[]): number =>
  groups.reduce((sum, group) => sum + groupTotalOf(group), 0);

/** 試卷列 → examGroups（種子/前次存檔寫回的子清單）。 */
function groupsOf(row: Row | null): ExamGroup[] {
  const value = row?.['examGroups'];
  return Array.isArray(value) ? (value as ExamGroup[]) : [];
}

export function ExamEditModal({
  pageId,
  mode,
  row,
  onClose,
  onClosed,
}: ExamEditModalProps): ReactElement {
  const dataSource = useDataSource();
  const dialogs = useDialogs();

  const isEdit = mode === 'edit' && row !== null;

  // ------------------------------------------------------------------
  // 試卷表單值（showModal :365-413）。
  // ------------------------------------------------------------------
  const [organizationId, setOrganizationId] = useState(isEdit ? String(row?.['organizationId'] ?? '') : '');
  const [jobTypeId, setJobTypeId] = useState(isEdit ? String(row?.['jobTypeId'] ?? '') : '');
  const [departmentId, setDepartmentId] = useState(isEdit ? String(row?.['departmentId'] ?? '') : '');
  const [code, setCode] = useState(isEdit ? String(row?.['code'] ?? '') : '');
  const [name, setName] = useState(isEdit ? String(row?.['name'] ?? '') : '');
  const [memo, setMemo] = useState(isEdit ? String(row?.['memo'] ?? '') : '');
  const [level, setLevel] = useState(isEdit ? String(row?.['level'] ?? '0') : '0'); // :377 預設 0（不限）
  const [isLimitedTime, setIsLimitedTime] = useState(isEdit ? String(row?.['isLimitedTime'] ?? '0') : '0');
  const [testingTime, setTestingTime] = useState(isEdit ? String(row?.['testingTime'] ?? '0') : '0');
  const [remindTime, setRemindTime] = useState(isEdit ? String(row?.['remindTime'] ?? '0') : '0');
  const [effectiveDate, setEffectiveDate] = useState(isEdit ? String(row?.['effectiveDate'] ?? '') : '');
  const [totalScore, setTotalScore] = useState(isEdit ? String(row?.['totalScore'] ?? '0') : '0');
  const [passingScore, setPassingScore] = useState(isEdit ? String(row?.['passingScore'] ?? '0') : '0');
  const [reviewTest, setReviewTest] = useState(isEdit ? String(row?.['reviewTest'] ?? '1') : '1'); // :378 預設 1（是）
  const [sort, setSort] = useState(isEdit ? String(row?.['sort'] ?? '0') : '0'); // :385 預設 0
  const [examGroups, setExamGroups] = useState<ExamGroup[]>(isEdit ? groupsOf(row) : []);
  /** 已存試卷列鍵；null＝尚未存檔（新增模式）。存檔後 org/jobType disabled（:386-387/:464-465）。 */
  const [examId, setExamId] = useState<string | null>(
    isEdit ? String(row?.id ?? '') : null,
  );
  const [fieldErrors, setFieldErrors] = useState<Record<string, string>>({});
  const [busy, setBusy] = useState(false);

  // ------------------------------------------------------------------
  // 子 modal 狀態（題組維護／選題／自動配分）。疊放，AccountV2DialogModal 先例。
  // ------------------------------------------------------------------
  const [groupDraft, setGroupDraft] = useState<ExamGroup | null>(null);
  const [groupErrors, setGroupErrors] = useState<Record<string, string>>({});
  const [produceOpen, setProduceOpen] = useState(false);
  const [qBankId, setQBankId] = useState('');
  const [qLevels, setQLevels] = useState<ReadonlySet<string>>(new Set());
  const [randomSize, setRandomSize] = useState('');
  const [produceRows, setProduceRows] = useState<readonly ExamQuestionPoolEntry[]>([]);
  const [produceSelected, setProduceSelected] = useState<ReadonlySet<string>>(new Set());
  const [produceErrors, setProduceErrors] = useState<Record<string, string>>({});
  const [bankOptions, setBankOptions] = useState<readonly { value: string; label: string }[]>([]);
  const [autoscoreOpen, setAutoscoreOpen] = useState(false);
  const [autoscoreTotal, setAutoscoreTotal] = useState('');
  const [autoscoreDist, setAutoscoreDist] = useState('0');
  const [autoscoreErrors, setAutoscoreErrors] = useState<Record<string, string>>({});

  /** 試卷 modal 標題（:29-30；存檔成功換『修改試卷』:450）。 */
  const examTitle = examId === null ? '新增試卷' : '修改試卷';
  /** org/jobType disabled：修改模式載入即鎖（:386-387）；新增模式存檔後鎖（:464-465）。 */
  const orgJobTypeLocked = examId !== null || busy;

  const saveSuccessText = () =>
    resolveLegacyMessage(pageId, 'success')?.text ?? t('state.saveSuccess');
  const alertOrGeneric = async (cause: unknown) => {
    await dialogs.alert(cause instanceof MockDataError ? cause.message : t('error.generic'));
  };

  // ------------------------------------------------------------------
  // 試卷表單驗證（jquery validate required inline；radio 恆有值不檢）。
  // ------------------------------------------------------------------
  const validateExamForm = (): boolean => {
    const errors: Record<string, string> = {};
    for (const key of [
      'organizationId',
      'jobTypeId',
      'departmentId',
      'code',
      'name',
      'testingTime',
      'remindTime',
      'effectiveDate',
      'passingScore',
      'sort',
    ]) {
      const value = {
        organizationId,
        jobTypeId,
        departmentId,
        code,
        name,
        testingTime,
        remindTime,
        effectiveDate,
        passingScore,
        sort,
      }[key];
      if ((value ?? '').trim() === '') {
        errors[key] = REQUIRED_TEXT;
      }
    }
    setFieldErrors(errors);
    return Object.keys(errors).length === 0;
  };

  // ------------------------------------------------------------------
  // 試卷存檔（save :415-466）。回 false＝驗證/寫入失敗（呼叫端中止）。
  // ------------------------------------------------------------------
  const persistExam = (isSave: boolean): Promise<boolean> =>
    (async () => {
      // 驗證鏈（順序固定）：inline required → alert 四段。
      if (!validateExamForm()) {
        return false;
      }
      // :417-421 jobType<=0 →『訓練類別未填寫』。空值已被 required 攔；此分支鏡像 legacy
      // 的數值哨兵（legacy 選項值是數字 id；雛形池值 jt-x parseInt 為 NaN → 不觸發）。
      if (Number.parseInt(jobTypeId, 10) <= 0) {
        await dialogs.alert('訓練類別未填寫'); // :419
        return false;
      }
      if (Number.parseInt(departmentId, 10) <= 0) {
        await dialogs.alert('部門未填寫'); // :422
        return false;
      }
      // :423-427 passingScore>totalScore 僅 **isSave**（legacy `isSave == true &&` 前綴；
      // save(false) 開題組/選題前不檢這條）。
      if (
        isSave &&
        Number.parseInt(passingScore, 10) > Number.parseInt(totalScore, 10)
      ) {
        await dialogs.alert('存檔失敗，及格分數大於總分，請修正。'); // :426
        return false;
      }
      // :428-431 限制作答時間（isLimitedTime==0）且 testingTime<=0。
      if (isLimitedTime === '0' && Number.parseInt(testingTime, 10) <= 0) {
        await dialogs.alert('考試時間須大於0'); // :430
        return false;
      }
      // :433 `if (isSave || exam == null)`：修改模式（exam!=null）且非存檔 → **只驗證不 POST**。
      if (!(isSave || examId === null)) {
        return true;
      }
      const payload: Row = {
        organizationId,
        jobTypeId,
        departmentId,
        code,
        name,
        memo,
        level,
        isLimitedTime,
        testingTime,
        remindTime,
        effectiveDate,
        totalScore,
        passingScore,
        reviewTest,
        sort,
        examGroups,
        // 表格欄鏡像（legacy formTable 由回傳欄位組表：試卷名稱 name/題數 cnt/試卷說明 memo）。
        title: name,
        score: examQtyOf(examGroups),
        title2: memo,
      };
      setBusy(true);
      try {
        const saved =
          examId === null
            ? await dialogs.processing.wrap(dataSource.create(pageId, payload))
            : await dialogs.processing.wrap(dataSource.update(pageId, examId, payload));
        setExamId(String(saved['id'] ?? examId ?? '')); // :440-442 id 回填
        onClosed(); // :439 doQuery（不論 isSave）
        if (isSave) {
          onClose(); // :458 modal('hide')（先關再 info，AccountV2DialogModal 前例）
          await dialogs.info(saveSuccessText()); // :444 showInfoDialog(response.desc)
        }
        return true;
      } catch (cause: unknown) {
        if (isSave) {
          await alertOrGeneric(cause); // :448-451 失敗 alert 僅 isSave（legacy 同）
        }
        return false;
      } finally {
        setBusy(false);
      }
    })();

  // ------------------------------------------------------------------
  // 關閉守衛（dialogModal hide.bs.modal :237-243）：passingScore>totalScore 不關閉。
  // ------------------------------------------------------------------
  const closeMainModal = () => {
    void (async () => {
      if (
        Number.parseInt(passingScore, 10) > Number.parseInt(totalScore, 10)
      ) {
        await dialogs.alert('及格分數大於總分，請修正。'); // :240
        return; // return false（不關閉）
      }
      onClose(); // legacy 無 hidden.bs.modal → doQuery 掛載（ AnnualEditModal 同款：reload 由存檔流程自帶）
    })();
  };

  // ------------------------------------------------------------------
  // 題組 modal（showGroupModal :576-604）。先 save(false) 自存/驗證試卷表單。
  // ------------------------------------------------------------------
  const openGroupModal = (group: ExamGroup | null) => {
    void (async () => {
      if (!(await persistExam(false))) {
        return; // :580 `if (save(false) != false)`
      }
      setGroupErrors({});
      setGroupDraft(
        group === null
          ? { id: null, name: '', sort: '', examType: '1', details: [] }
          : { ...group, details: group.details.map((detail) => ({ ...detail })) },
      );
      // 新增：totalScore/qty 顯示 0（:586-587）＝空 details 計算值，不需另外設。
    })();
  };

  /** 題組草稿寫入 examGroups（新增給本地編號；修改整組取代）。回更新後的群組陣列。 */
  const upsertGroup = (draft: ExamGroup, id: string): readonly ExamGroup[] => {
    const exists = examGroups.some((group) => group.id === id);
    return exists
      ? examGroups.map((group) => (group.id === id ? draft : group))
      : [...examGroups, { ...draft, id }];
  };

  // ------------------------------------------------------------------
  // 題組存檔（saveGroup :606-674）。
  // ------------------------------------------------------------------
  const saveGroup = (isSave: boolean): Promise<boolean> =>
    (async () => {
      const draft = groupDraft;
      if (draft === null || examId === null) {
        return false;
      }
      const errors: Record<string, string> = {};
      if (draft.name.trim() === '') {
        errors.name = REQUIRED_TEXT;
      }
      if (draft.sort.trim() === '') {
        errors.sort = REQUIRED_TEXT;
      }
      setGroupErrors(errors);
      if (Object.keys(errors).length > 0) {
        return false;
      }
      const newId = draft.id ?? `eg-9${String(examGroups.length + 1).padStart(3, '0')}`; // 雛形本地編號
      const nextGroups = upsertGroup({ ...draft, id: newId }, newId);
      const newTotal = examTotalOf(nextGroups);
      const newQty = examQtyOf(nextGroups);
      setBusy(true);
      try {
        // saveExamGroupAjax 鏡像：整組寫回列上（examGroups＋totalScore＋題數欄）。
        await dialogs.processing.wrap(
          dataSource.update(pageId, examId, {
            examGroups: nextGroups,
            totalScore: newTotal,
            score: newQty,
          }),
        );
        setExamGroups([...nextGroups]);
        setTotalScore(String(newTotal)); // :640 inputForm totalScore=response.totalScore
        if (draft.id === null) {
          setGroupDraft({ ...draft, id: newId });
        }
        // :642-664 總分<及格 且 isSave → 自動調整及格分數確認鏈。
        if (newTotal < Number.parseInt(passingScore, 10) && isSave) {
          const confirmed = await dialogs.confirm('目前總分低於及格分數，是否由系統自動調整及格分數?'); // :644
          if (confirmed) {
            // 內層 updateExamAjax（:646-658）；showInfoDialog(suctext) 在 success 判斷**外**
            // （:655）——內層失敗也顯示，照實鏡像（R2 複驗 F8）。
            try {
              await dialogs.processing.wrap(
                dataSource.update(pageId, examId, { passingScore: String(newTotal) }),
              );
              setPassingScore(String(newTotal)); // :652-653 inputForm passingScore=totalScore
            } catch {
              // 內層失敗：照 legacy 繼續顯示 suctext（:655 在 success 判斷外）。
            }
            await dialogs.info(saveSuccessText()); // :655 showInfoDialog(suctext)
          } else {
            await dialogs.info(`${saveSuccessText()} 試卷存檔時，請記得修改及格分數。`); // :659
          }
        }
        // 總分>=及格：legacy 無 info（靜默）。
        if (isSave) {
          setGroupDraft(null); // modal('hide')（:670）
        }
        return true;
      } catch (cause: unknown) {
        await alertOrGeneric(cause);
        return false;
      } finally {
        setBusy(false);
      }
    })();

  // ------------------------------------------------------------------
  // 選題 modal 前置：showGenModal → saveGroup(false)（:714-732）。
  // saveGroup(false) 的 legacy 語意（:611 `if (isSave || examGroup == null)`）：
  // 新題組（examGroup==null）先建立（saveExamDetail 需要 group id）；既有題組只驗證。
  // 回題組列鍵；null＝中止。
  // ------------------------------------------------------------------
  const persistGroupForProduce = (): Promise<string | null> =>
    (async () => {
      const draft = groupDraft;
      if (draft === null || examId === null) {
        return null;
      }
      const errors: Record<string, string> = {};
      if (draft.name.trim() === '') {
        errors.name = REQUIRED_TEXT;
      }
      if (draft.sort.trim() === '') {
        errors.sort = REQUIRED_TEXT;
      }
      setGroupErrors(errors);
      if (Object.keys(errors).length > 0) {
        return null;
      }
      if (draft.id !== null) {
        return draft.id; // 既有題組：只驗證（name/sort 草稿不寫回＝legacy 同）
      }
      const newId = `eg-9${String(examGroups.length + 1).padStart(3, '0')}`;
      const nextGroups = upsertGroup(draft, newId);
      const newTotal = examTotalOf(nextGroups);
      const newQty = examQtyOf(nextGroups);
      setBusy(true);
      try {
        await dialogs.processing.wrap(
          dataSource.update(pageId, examId, {
            examGroups: nextGroups,
            totalScore: newTotal,
            score: newQty,
          }),
        );
        setExamGroups([...nextGroups]);
        setTotalScore(String(newTotal));
        setGroupDraft({ ...draft, id: newId });
        return newId;
      } catch (cause: unknown) {
        await alertOrGeneric(cause);
        return null;
      } finally {
        setBusy(false);
      }
    })();

  // ------------------------------------------------------------------
  // 選題 modal（showGenModal :714-732）。
  // ------------------------------------------------------------------
  const openProduceModal = () => {
    void (async () => {
      const groupId = await persistGroupForProduce();
      if (groupId === null || groupDraft === null) {
        return;
      }
      // 標題與分區（:721-730）：examType 2→隨機出題（qSelectDiv 藏）；其他→從題庫選擇。
      setProduceErrors({});
      setQBankId('');
      setQLevels(new Set());
      setRandomSize('');
      setProduceRows([]);
      setProduceSelected(new Set());
      // 題庫下拉（getQuestionBankListAjax by jobTypeId :285-321；雛形以題庫清單平列）。
      try {
        const banks = await dialogs.processing.wrap(dataSource.list('exam-question-bank'));
        setBankOptions(
          banks.rows.map((bank) => ({ value: String(bank.id), label: String(bank.title ?? '') })),
        );
      } catch (cause: unknown) {
        await alertOrGeneric(cause);
        return;
      }
      setProduceOpen(true);
    })();
  };

  /** 題庫下拉關閉時的 placeholder（legacy prepend『請選擇』disabled selected hidden :313/:320）。 */
  const bankSelectOptions = [{ value: '', label: '請選擇' }, ...bankOptions];

  /** getQuestion（:814-846；僅 examType=='1' 由呼叫端守衛）。level 全未勾＝不過濾【雛形值待實機校準】。 */
  const poolOf = (bankId: string): readonly ExamQuestionPoolEntry[] =>
    EXAM_QUESTION_POOL[bankId] ?? [];
  const refreshProduceRows = (nextBankId: string, nextLevels: ReadonlySet<string>) => {
    if (groupDraft?.examType !== '1') {
      return; // :324-334 僅從題庫選題（examType=='1'）
    }
    const rows = (nextBankId === '' ? [] : filteredPoolOf(nextBankId, nextLevels));
    setProduceRows(rows);
    setProduceSelected(new Set(rows.map((question) => question.questionId))); // rows_selected=全部
  };
  const filteredPoolOf = (
    bankId: string,
    levels: ReadonlySet<string>,
  ): readonly ExamQuestionPoolEntry[] => {
    const pool = poolOf(bankId);
    if (levels.size === 0) {
      return pool;
    }
    return pool.filter((question) => levels.has(question.level));
  };

  // ------------------------------------------------------------------
  // 選題存檔（saveExamDetail :734-791）。
  // ------------------------------------------------------------------
  const saveProduce = () => {
    void (async () => {
      const draft = groupDraft;
      if (draft === null || draft.id === null || examId === null) {
        return;
      }
      // produceQuestionForm valid：randomSize required 僅隨機模式（select 模式該欄在隱藏 div
      // 內＝jquery validate 忽略 hidden）；qBankId 無 required（HTML select :1314，option 選擇題庫 :1315）。
      if (draft.examType === '2' && randomSize.trim() === '') {
        setProduceErrors({ randomSize: REQUIRED_TEXT });
        return;
      }
      // min="1"（examManage.jsp:1351-1357）；min 訊息＝jquery validate 全域設定
      // （decorator.jsp:279「不可小於 {0}.」→ 不可小於 1.）。
      if (
        draft.examType === '2' &&
        (Number.isNaN(Number.parseInt(randomSize, 10)) || Number.parseInt(randomSize, 10) < 1)
      ) {
        setProduceErrors({ randomSize: '不可小於 1.' });
        return;
      }
      setProduceErrors({});
      const isRandom = draft.examType === '2'; // :740
      let picked: readonly ExamQuestionPoolEntry[];
      if (isRandom) {
        // :741-743 randomSize（null→0）；隨機在後端——雛形取過濾後題池前 N 筆【雛形值待實機校準】。
        const size = Number.parseInt(randomSize, 10) || 0;
        picked = filteredPoolOf(qBankId, qLevels).slice(0, size);
      } else {
        // rows_selected 中**有勾者**（:758-763）。
        picked = produceRows.filter((question) => produceSelected.has(question.questionId));
      }
      const stored = examGroups.find((group) => group.id === draft.id);
      if (stored === undefined) {
        return;
      }
      const startSort = stored.details.length;
      const newDetails: ExamGroupDetail[] = picked.map((question, index) => ({
        id: `egd-9${String(startSort + index + 1).padStart(3, '0')}`, // 雛形本地編號
        questionId: question.questionId,
        sort: String(startSort + index + 1),
        score: '0', // 新選題配分預設 0【雛形值待實機校準】（legacy 由 server 定）
        bankName: bankOptions.find((option) => option.value === qBankId)?.label ?? '',
        questionType: question.questionType,
        content: question.content,
        answer: question.answer,
        level: question.level,
      }));
      const updated = { ...stored, details: [...stored.details, ...newDetails] };
      const nextGroups = examGroups.map((group) => (group.id === draft.id ? updated : group));
      const newTotal = examTotalOf(nextGroups);
      const newQty = examQtyOf(nextGroups);
      setBusy(true);
      try {
        await dialogs.processing.wrap(
          dataSource.update(pageId, examId, {
            examGroups: nextGroups,
            totalScore: newTotal,
            score: newQty,
          }),
        );
        setExamGroups([...nextGroups]);
        setTotalScore(String(newTotal));
        // getExamDetailList 重灌 questionTable（:778-779）；name/sort 草稿保持不動（legacy 同）。
        setGroupDraft({ ...draft, details: [...updated.details] });
        onClosed(); // doQuery（:777）
        setProduceOpen(false); // .always 關 modal（:787-788）
        await dialogs.info(saveSuccessText()); // :780
      } catch (cause: unknown) {
        await alertOrGeneric(cause);
      } finally {
        setBusy(false);
      }
    })();
  };

  // ------------------------------------------------------------------
  // 題組刪除（delExamGroup :676-691）。totalScore 照實不重算（legacy 刪除不回寫 inputForm 總分）。
  // ------------------------------------------------------------------
  const deleteGroup = (id: string) => {
    void (async () => {
      const confirmed = await dialogs.confirm('是否確定要刪除?'); // :677
      if (!confirmed || examId === null) {
        return;
      }
      const nextGroups = examGroups.filter((group) => group.id !== id);
      setBusy(true);
      try {
        await dialogs.processing.wrap(dataSource.update(pageId, examId, { examGroups: nextGroups }));
        setExamGroups([...nextGroups]);
        await dialogs.info(saveSuccessText()); // :686 showInfoDialog(response.desc)
      } catch (cause: unknown) {
        await alertOrGeneric(cause);
      } finally {
        setBusy(false);
      }
    })();
  };

  // ------------------------------------------------------------------
  // 題目刪除（delQuestion :793-808）：立即寫回＋刷新三表（doQuery 鏡像＝onClosed）。
  // ------------------------------------------------------------------
  const deleteDetail = (detailId: string) => {
    void (async () => {
      const draft = groupDraft;
      if (draft === null || draft.id === null || examId === null) {
        return;
      }
      const confirmed = await dialogs.confirm('是否確定要刪除?'); // :794
      if (!confirmed) {
        return;
      }
      const stored = examGroups.find((group) => group.id === draft.id);
      if (stored === undefined) {
        return;
      }
      const updated = {
        ...stored,
        details: stored.details.filter((detail) => detail.id !== detailId),
      };
      const nextGroups = examGroups.map((group) => (group.id === draft.id ? updated : group));
      const newTotal = examTotalOf(nextGroups);
      const newQty = examQtyOf(nextGroups);
      setBusy(true);
      try {
        await dialogs.processing.wrap(
          dataSource.update(pageId, examId, {
            examGroups: nextGroups,
            totalScore: newTotal,
            score: newQty,
          }),
        );
        setExamGroups([...nextGroups]);
        setTotalScore(String(newTotal));
        setGroupDraft({ ...draft, details: [...updated.details] });
        onClosed(); // doQuery（:801）
        await dialogs.info(saveSuccessText()); // :805
      } catch (cause: unknown) {
        await alertOrGeneric(cause);
      } finally {
        setBusy(false);
      }
    })();
  };

  // ------------------------------------------------------------------
  // 自動配分（autoScoreSet :848-896；common.prompt 鏡像為小 modal）。
  // ------------------------------------------------------------------
  const applyAutoscore = () => {
    const draft = groupDraft;
    if (draft === null) {
      return;
    }
    const raw = autoscoreTotal.trim();
    if (raw === '') {
      setAutoscoreErrors({ total: '分數不可空白' }); // :863
      return;
    }
    setAutoscoreErrors({});
    const target = Number.parseFloat(raw);
    const size = draft.details.length;
    // legacy 同款算式（:867-893）；size==0 時 avgScore*scoreSize=NaN≠target → 不整除 alert。
    if (autoscoreDist === '0') {
      const avg = Math.floor((target / size) * 100) / 100;
      if (avg * size !== target) {
        void dialogs.alert('自動配分需要能整除'); // :871
        return;
      }
      setGroupDraft({
        ...draft,
        details: draft.details.map((detail) => ({ ...detail, score: String(avg) })),
      });
    } else {
      // 1/2：remainder 歸首題/末題——legacy `.0`/`.末` class selector 無對應元素，餘數實際
      // 沒套上（legacy-known-issue 照實不修）：全部設 avg。
      const remainder = target % size;
      const avg = (target - remainder) / size;
      setGroupDraft({
        ...draft,
        details: draft.details.map((detail) => ({ ...detail, score: String(avg) })),
      });
    }
    setAutoscoreOpen(false);
  };

  // ------------------------------------------------------------------
  // 畫面
  // ------------------------------------------------------------------
  const examFieldError = (key: string) =>
    fieldErrors[key] === undefined ? null : (
      <div data-ui-id={`${pageId}-exam-error-${key}`} className="text-xs text-danger">
        {fieldErrors[key]}
      </div>
    );

  const examField = (key: string, label: string, required: boolean, control: ReactElement) => (
    <div className="flex items-start gap-2">
      {/* 批次 50（工作項 4）：htmlFor 字尾 toUiKey kebab 化，與呼叫端 kebab 字面 uiId 成對
          （examFieldError 的 `${key}` 是 fieldErrors/payload key 域＝opaque 另案不動）。 */}
      <label className="w-24 shrink-0 text-sm" htmlFor={`${pageId}-exam-field-${toUiKey(key)}`}>
        {required ? <span className="text-danger">*</span> : null}
        {label}
      </label>
      <div>
        {control}
        {examFieldError(key)}
      </div>
    </div>
  );

  const groupTableColumns: readonly TableColumn[] = [
    { key: 'delete', header: '', align: 'center' },
    { key: 'name', header: '題組名稱', align: 'center' },
    { key: 'qty', header: '總題數', align: 'center' },
    { key: 'totalScore', header: '配分', align: 'center' },
    { key: 'preview', header: '預覽', align: 'center' },
    { key: 'sort', header: '排序', align: 'center' },
  ];

  const groupTableRows: readonly TableRow[] = examGroups.map((group) => ({
    id: group.id,
    name: group.name,
    qty: groupQtyOf(group),
    totalScore: groupTotalOf(group),
    sort: group.sort,
  }));

  const detailTableColumns: readonly TableColumn[] = [
    { key: 'delete', header: '', align: 'center' },
    { key: 'no', header: 'No.', align: 'center' },
    { key: 'bankName', header: '題庫', align: 'left' },
    { key: 'questionType', header: '題型', align: 'left' },
    { key: 'content', header: '題目', align: 'left' },
    { key: 'answer', header: '答案', align: 'left' },
    { key: 'level', header: '難度', align: 'center' },
    { key: 'score', header: '配分', align: 'center' },
    { key: 'sort', header: '排序', align: 'center' },
  ];

  const produceColumns: readonly TableColumn[] = [
    { key: 'check', header: '', align: 'center' },
    { key: 'questionType', header: '題型', align: 'left' },
    { key: 'content', header: '題目', align: 'left' },
    { key: 'answer', header: '答案', align: 'left' },
    { key: 'level', header: '難易度', align: 'center' },
  ];

  const allProduceChecked =
    produceRows.length > 0 && produceRows.every((question) => produceSelected.has(question.questionId));

  return (
    <>
      {/* ── 試卷大 modal（#dialogModal） ── */}
      <ModalFrame
        uiId={`${pageId}-exam-dialog`}
        open
        title={examTitle}
        size="lg"
        onClose={closeMainModal}
        footer={
          <>
            <Button
              uiId={`${pageId}-exam-dialog-cancel`}
              variant="default"
              size="sm"
              type="button"
              onClick={closeMainModal}
            >
              關閉
            </Button>
            <Button
              uiId={`${pageId}-exam-dialog-save`}
              variant="primary"
              size="sm"
              type="button"
              disabled={busy}
              // C5-j：存檔真的呼叫 dataSource.create/update。
              dataEffect={`${examId === null ? 'create' : 'update'}:${pageId}`}
              onClick={() => {
                void persistExam(true);
              }}
            >
              存檔
            </Button>
          </>
        }
      >
        <div data-ui-id={`${pageId}-exam-dialog-body`} className="space-y-3">
          {examField('organizationId', '醫院：', true, (
            <Select
              uiId={`${pageId}-exam-field-organization-id`}
              value={organizationId}
              onChange={setOrganizationId}
              options={ACCOUNT_ORGANIZATION_OPTIONS}
              disabled={orgJobTypeLocked}
              invalid={fieldErrors.organizationId !== undefined}
              placeholder="請選擇"
            />
          ))}
          {examField('jobTypeId', '訓練類別：', true, (
            <Select
              uiId={`${pageId}-exam-field-job-type-id`}
              value={jobTypeId}
              onChange={setJobTypeId}
              options={ACCOUNT_JOB_TYPE_OPTIONS}
              disabled={orgJobTypeLocked}
              invalid={fieldErrors.jobTypeId !== undefined}
              placeholder="請選擇"
            />
          ))}
          {examField('departmentId', '部門：', true, (
            <Select
              uiId={`${pageId}-exam-field-department-id`}
              value={departmentId}
              onChange={setDepartmentId}
              options={ACCOUNT_DEPARTMENT_OPTIONS}
              disabled={busy}
              invalid={fieldErrors.departmentId !== undefined}
              placeholder="請選擇"
            />
          ))}
          {examField('code', '試卷代碼：', true, (
            <TextInput
              uiId={`${pageId}-exam-field-code`}
              value={code}
              onChange={setCode}
              maxLength={100}
              disabled={busy}
              invalid={fieldErrors.code !== undefined}
            />
          ))}
          {examField('name', '試卷名稱：', true, (
            <TextInput
              uiId={`${pageId}-exam-field-name`}
              value={name}
              onChange={setName}
              maxLength={100}
              disabled={busy}
              invalid={fieldErrors.name !== undefined}
            />
          ))}
          {examField('memo', '試卷說明：', false, (
            <Textarea uiId={`${pageId}-exam-field-memo`} value={memo} onChange={setMemo} disabled={busy} />
          ))}
          {/* 難易度（:1048-1077 radio 4，預設 0 不限）。 */}
          <div className="flex items-start gap-2">
            <span className="w-24 shrink-0 text-sm">
              <span className="text-danger">*</span>難易度：
            </span>
            <div className="flex items-center gap-3">
              {EXAM_LEVEL_OPTIONS.map((option) => (
                <Radio
                  key={option.value}
                  uiId={`${pageId}-exam-field-level${option.value}`}
                  name="level"
                  checked={level === option.value}
                  onChange={(checked) => {
                    if (checked) {
                      setLevel(option.value);
                    }
                  }}
                  disabled={busy}
                  label={option.label}
                />
              ))}
            </div>
          </div>
          {/* 作答時間（:1084-1089 radio 2：0=限制作答時間/1=不限作答時間；change 連動 :225-233）。 */}
          <div className="flex items-start gap-2">
            <span className="w-24 shrink-0 text-sm">
              <span className="text-danger">*</span>作答時間：
            </span>
            <div className="flex items-center gap-3">
              <Radio
                uiId={`${pageId}-exam-field-is-limited-time0`}
                name="isLimitedTime"
                checked={isLimitedTime === '0'}
                onChange={(checked) => {
                  if (checked) {
                    setIsLimitedTime('0');
                    setTestingTime('0'); // :230-231 兩分支都把值清 0（legacy 同）
                    setRemindTime('0');
                  }
                }}
                disabled={busy}
                label="限制作答時間"
              />
              <Radio
                uiId={`${pageId}-exam-field-is-limited-time1`}
                name="isLimitedTime"
                checked={isLimitedTime === '1'}
                onChange={(checked) => {
                  if (checked) {
                    setIsLimitedTime('1');
                    setTestingTime('0'); // :227-228 disabled＋val(0)
                    setRemindTime('0');
                  }
                }}
                disabled={busy}
                label="不限作答時間"
              />
            </div>
          </div>
          {examField('testingTime', '考試時間：', true, (
            <div className="flex items-center gap-1">
              <TextInput
                uiId={`${pageId}-exam-field-testing-time`}
                value={testingTime}
                onChange={setTestingTime}
                disabled={busy || isLimitedTime === '1'} // :226-227
                invalid={fieldErrors.testingTime !== undefined}
              />
              分鐘
            </div>
          ))}
          {examField('remindTime', '提醒時間：', true, (
            <div className="flex items-center gap-1">
              <TextInput
                uiId={`${pageId}-exam-field-remind-time`}
                value={remindTime}
                onChange={setRemindTime}
                disabled={busy || isLimitedTime === '1'} // :226-227
                invalid={fieldErrors.remindTime !== undefined}
              />
              分鐘前 (若為0, 則不提醒)
            </div>
          ))}
          {examField('effectiveDate', '生效日：', true, (
            <TextInput
              uiId={`${pageId}-exam-field-effective-date`}
              value={effectiveDate}
              onChange={setEffectiveDate}
              disabled={busy}
              invalid={fieldErrors.effectiveDate !== undefined}
            />
          ))}
          {/* 總分（:1124-1130 readonly；存題組後由 saveGroup 回寫）。 */}
          {examField('totalScore', '總分：', false, (
            <TextInput
              uiId={`${pageId}-exam-field-total-score`}
              value={totalScore}
              onChange={setTotalScore}
              readOnly
              disabled={busy}
            />
          ))}
          {examField('passingScore', '及格分數：', true, (
            <TextInput
              uiId={`${pageId}-exam-field-passing-score`}
              value={passingScore}
              onChange={setPassingScore}
              disabled={busy}
              invalid={fieldErrors.passingScore !== undefined}
            />
          ))}
          {/* 學生可查考卷（:1139-1146 radio 是1/否0，預設是）。 */}
          <div className="flex items-start gap-2">
            <span className="w-24 shrink-0 text-sm">
              <span className="text-danger">*</span>學生可查考卷：
            </span>
            <div className="flex items-center gap-3">
              <Radio
                uiId={`${pageId}-exam-field-review-test1`}
                name="reviewTest"
                checked={reviewTest === '1'}
                onChange={(checked) => {
                  if (checked) {
                    setReviewTest('1');
                  }
                }}
                disabled={busy}
                label="是"
              />
              <Radio
                uiId={`${pageId}-exam-field-review-test0`}
                name="reviewTest"
                checked={reviewTest === '0'}
                onChange={(checked) => {
                  if (checked) {
                    setReviewTest('0');
                  }
                }}
                disabled={busy}
                label="否"
              />
            </div>
          </div>
          {examField('sort', '排序序號：', true, (
            <TextInput
              uiId={`${pageId}-exam-field-sort`}
              value={sort}
              onChange={setSort}
              disabled={busy}
              invalid={fieldErrors.sort !== undefined}
            />
          ))}
          {/* 題組（groupListDiv :1157-1192：新增題組 :1163＋預覽＋examGroupTable 六欄）。 */}
          <div className="flex items-start gap-2">
            <span className="w-24 shrink-0 text-sm">
              <span className="text-danger">*</span>題組：
            </span>
            <div className="min-w-0 flex-1">
              <div className="mb-2 flex items-center gap-2">
                <Button
                  uiId={`${pageId}-exam-dialog-add-group`}
                  variant="primary"
                  size="sm"
                  type="button"
                  disabled={busy}
                  onClick={() => {
                    openGroupModal(null);
                  }}
                >
                  新增題組
                </Button>
                <Button
                  uiId={`${pageId}-exam-dialog-preview`}
                  variant="default"
                  size="sm"
                  type="button"
                  // testPreview（:898-901）開新頁 previewTesting；雛形以提示呈現（B1-3 模式）。
                  onClick={() => {
                    void dialogs.info(t('export.notice'));
                  }}
                >
                  預覽
                </Button>
              </div>
              <Table
                uiId={`${pageId}-exam-dialog-group-table`}
                columns={groupTableColumns}
                rows={groupTableRows}
                rowKey={(tableRow) => String(tableRow['id'] ?? '')}
                renderCell={(tableRow, columnKey) => {
                  const groupId = String(tableRow['id'] ?? '');
                  if (columnKey === 'delete') {
                    return (
                      <Button
                        uiId={`${pageId}-exam-dialog-group-row-${groupId}-delete`}
                        variant="default"
                        size="sm"
                        type="button"
                        disabled={busy}
                        onClick={() => {
                          deleteGroup(groupId);
                        }}
                      >
                        刪除
                      </Button>
                    );
                  }
                  if (columnKey === 'name') {
                    return (
                      <button
                        type="button"
                        data-ui-id={`${pageId}-exam-dialog-group-row-${groupId}-open`}
                        className="text-brand underline"
                        onClick={() => {
                          const group = examGroups.find((entry) => entry.id === groupId);
                          if (group !== undefined) {
                            openGroupModal(group);
                          }
                        }}
                      >
                        {String(tableRow['name'] ?? '')}
                      </button>
                    );
                  }
                  if (columnKey === 'preview') {
                    return (
                      <Button
                        uiId={`${pageId}-exam-dialog-group-row-${groupId}-preview`}
                        variant="default"
                        size="sm"
                        type="button"
                        onClick={() => {
                          void dialogs.info(t('export.notice'));
                        }}
                      >
                        預覽
                      </Button>
                    );
                  }
                  return String(tableRow[columnKey] ?? '');
                }}
              />
            </div>
          </div>
        </div>
      </ModalFrame>

      {/* ── 題組維護 modal（#examGroupModal，examManage.jsp:1194-1298） ── */}
      {groupDraft === null ? null : (
        <ModalFrame
          uiId={`${pageId}-group-dialog`}
          open
          title="題組維護"
          size="lg"
          onClose={() => {
            setGroupDraft(null);
          }}
          footer={
            <>
              <Button
                uiId={`${pageId}-group-dialog-cancel`}
                variant="default"
                size="sm"
                type="button"
                onClick={() => {
                  setGroupDraft(null);
                }}
              >
                關閉
              </Button>
              <Button
                uiId={`${pageId}-group-dialog-save`}
                variant="primary"
                size="sm"
                type="button"
                disabled={busy}
                // C5-j：saveGroup 真的呼叫 dataSource.update（試卷列）。
                dataEffect={`update:${pageId}`}
                onClick={() => {
                  void saveGroup(true);
                }}
              >
                存檔
              </Button>
            </>
          }
        >
          <div data-ui-id={`${pageId}-group-dialog-body`} className="space-y-3">
            <div className="flex items-start gap-2">
              <label className="w-24 shrink-0 text-sm" htmlFor={`${pageId}-group-field-name`}>
                <span className="text-danger">*</span>題組名稱：
              </label>
              <div>
                <TextInput
                  uiId={`${pageId}-group-field-name`}
                  value={groupDraft.name}
                  onChange={(next) => {
                    setGroupDraft({ ...groupDraft, name: next });
                  }}
                  maxLength={100}
                  disabled={busy}
                  invalid={groupErrors.name !== undefined}
                />
                {groupErrors.name === undefined ? null : (
                  <div data-ui-id={`${pageId}-group-error-name`} className="text-xs text-danger">
                    {groupErrors.name}
                  </div>
                )}
              </div>
            </div>
            {/* 題組總分/題組題數（唯讀 label，:1226-1237；由 details 計算）。 */}
            <div className="flex items-start gap-2">
              <span className="w-24 shrink-0 text-sm">題組總分：</span>
              <span data-ui-id={`${pageId}-group-field-total-score`}>{groupTotalOf(groupDraft)}</span>
            </div>
            <div className="flex items-start gap-2">
              <span className="w-24 shrink-0 text-sm">題組題數：</span>
              <span data-ui-id={`${pageId}-group-field-qty`}>{groupQtyOf(groupDraft)}</span>
            </div>
            <div className="flex items-start gap-2">
              <label className="w-24 shrink-0 text-sm" htmlFor={`${pageId}-group-field-sort`}>
                <span className="text-danger">*</span>排序：
              </label>
              <div>
                <TextInput
                  uiId={`${pageId}-group-field-sort`}
                  value={groupDraft.sort}
                  onChange={(next) => {
                    setGroupDraft({ ...groupDraft, sort: next });
                  }}
                  maxLength={100}
                  disabled={busy}
                  invalid={groupErrors.sort !== undefined}
                />
                {groupErrors.sort === undefined ? null : (
                  <div data-ui-id={`${pageId}-group-error-sort`} className="text-xs text-danger">
                    {groupErrors.sort}
                  </div>
                )}
              </div>
            </div>
            {/* 出題方式（:1247-1263：select :1250-1253＋選擇題目 :1256＋自動配分 :1262）。 */}
            <div className="flex items-start gap-2">
              <span className="w-24 shrink-0 text-sm">出題方式：</span>
              <div className="flex items-center gap-2">
                <Select
                  uiId={`${pageId}-group-field-exam-type`}
                  value={groupDraft.examType}
                  onChange={(next) => {
                    setGroupDraft({ ...groupDraft, examType: next });
                  }}
                  options={EXAM_EXAM_TYPE_OPTIONS}
                  disabled={busy}
                />
                <Button
                  uiId={`${pageId}-group-dialog-produce`}
                  variant="primary"
                  size="sm"
                  type="button"
                  disabled={busy}
                  onClick={() => {
                    openProduceModal();
                  }}
                >
                  +選擇題目
                </Button>
                <Button
                  uiId={`${pageId}-group-dialog-autoscore`}
                  variant="primary"
                  size="sm"
                  type="button"
                  disabled={busy}
                  onClick={() => {
                    setAutoscoreTotal('');
                    setAutoscoreDist('0');
                    setAutoscoreErrors({});
                    setAutoscoreOpen(true);
                  }}
                >
                  自動配分
                </Button>
              </div>
            </div>
            {/* 題目內容（questionTable :1270-1290 九欄；配分/排序 inline 輸入，q_columns :76-160）。 */}
            <div className="flex items-start gap-2">
              <span className="w-24 shrink-0 text-sm">
                <span className="text-danger">*</span>題目內容：
              </span>
              <div className="min-w-0 flex-1">
                <Table
                  uiId={`${pageId}-group-table`}
                  columns={detailTableColumns}
                  rows={groupDraft.details.map((detail, index) => ({ ...detail, no: index + 1 }))}
                  rowKey={(tableRow) => String(tableRow['id'] ?? '')}
                  renderCell={(tableRow, columnKey) => {
                    const detailId = String(tableRow['id'] ?? '');
                    const draft = groupDraft;
                    const detail = draft.details.find((entry) => entry.id === detailId);
                    if (detail === undefined) {
                      return null;
                    }
                    if (columnKey === 'delete') {
                      return (
                        <Button
                          uiId={`${pageId}-group-table-row-${detailId}-delete`}
                          variant="default"
                          size="sm"
                          type="button"
                          disabled={busy}
                          onClick={() => {
                            deleteDetail(detailId);
                          }}
                        >
                          刪除
                        </Button>
                      );
                    }
                    if (columnKey === 'questionType') {
                      return EXAM_QUESTION_TYPE_TEXT[detail.questionType] ?? detail.questionType;
                    }
                    if (columnKey === 'level') {
                      return examDifficultyText(detail.level);
                    }
                    if (columnKey === 'score') {
                      return (
                        <TextInput
                          uiId={`${pageId}-group-table-row-${detailId}-score`}
                          value={detail.score}
                          onChange={(next) => {
                            setGroupDraft({
                              ...draft,
                              details: draft.details.map((entry) =>
                                entry.id === detailId ? { ...entry, score: next } : entry,
                              ),
                            });
                          }}
                          disabled={busy}
                        />
                      );
                    }
                    if (columnKey === 'sort') {
                      return (
                        <TextInput
                          uiId={`${pageId}-group-table-row-${detailId}-sort`}
                          value={detail.sort}
                          onChange={(next) => {
                            setGroupDraft({
                              ...draft,
                              details: draft.details.map((entry) =>
                                entry.id === detailId ? { ...entry, sort: next } : entry,
                              ),
                            });
                          }}
                          disabled={busy}
                        />
                      );
                    }
                    return String(tableRow[columnKey] ?? '');
                  }}
                />
              </div>
            </div>
          </div>
        </ModalFrame>
      )}

      {/* ── 選題 modal（#produceQuestionDiv，examManage.jsp:1300-1388；標題依 examType :721-730） ── */}
      {groupDraft === null || !produceOpen ? null : (
        <ModalFrame
          uiId={`${pageId}-produce-dialog`}
          open
          title={groupDraft.examType === '2' ? '隨機出題' : '從題庫選擇'}
          size="lg"
          onClose={() => {
            setProduceOpen(false);
          }}
          footer={
            <>
              <Button
                uiId={`${pageId}-produce-dialog-cancel`}
                variant="default"
                size="sm"
                type="button"
                onClick={() => {
                  setProduceOpen(false);
                }}
              >
                關閉
              </Button>
              <Button
                uiId={`${pageId}-produce-dialog-save`}
                variant="primary"
                size="sm"
                type="button"
                disabled={busy}
                // C5-j：saveExamDetail 真的呼叫 dataSource.update（試卷列的 examGroups）。
                dataEffect={`update:${pageId}`}
                onClick={() => {
                  saveProduce();
                }}
              >
                存檔
              </Button>
            </>
          }
        >
          <div data-ui-id={`${pageId}-produce-dialog-body`} className="space-y-3">
            {/* 題庫（:1313-1322；placeholder 請選擇 disabled hidden）。 */}
            <div className="flex items-start gap-2">
              <label className="w-24 shrink-0 text-sm" htmlFor={`${pageId}-produce-field-q-bank-id`}>
                <span className="text-danger">*</span>題庫：
              </label>
              <Select
                uiId={`${pageId}-produce-field-q-bank-id`}
                value={qBankId}
                onChange={(next) => {
                  setQBankId(next);
                  refreshProduceRows(next, qLevels); // :309-313（examType=='1' 時）
                }}
                options={bankSelectOptions}
                disabled={busy}
              />
            </div>
            {/* 難易度 checkbox 3（:1325-1343：易1/中5/難10）。 */}
            <div className="flex items-start gap-2">
              <span className="w-24 shrink-0 text-sm">
                <span className="text-danger">*</span>難易度：
              </span>
              <div className="flex items-center gap-3">
                <Checkbox
                  uiId={`${pageId}-produce-field-level1`}
                  name="qlevel"
                  checked={qLevels.has('1')}
                  label="易"
                  disabled={busy}
                  onChange={(checked) => {
                    const next = new Set(qLevels);
                    if (checked) {
                      next.add('1');
                    } else {
                      next.delete('1');
                    }
                    setQLevels(next);
                    refreshProduceRows(qBankId, next); // :314-319
                  }}
                />
                <Checkbox
                  uiId={`${pageId}-produce-field-level5`}
                  name="qlevel"
                  checked={qLevels.has('5')}
                  label="中"
                  disabled={busy}
                  onChange={(checked) => {
                    const next = new Set(qLevels);
                    if (checked) {
                      next.add('5');
                    } else {
                      next.delete('5');
                    }
                    setQLevels(next);
                    refreshProduceRows(qBankId, next);
                  }}
                />
                <Checkbox
                  uiId={`${pageId}-produce-field-level10`}
                  name="qlevel"
                  checked={qLevels.has('10')}
                  label="難"
                  disabled={busy}
                  onChange={(checked) => {
                    const next = new Set(qLevels);
                    if (checked) {
                      next.add('10');
                    } else {
                      next.delete('10');
                    }
                    setQLevels(next);
                    refreshProduceRows(qBankId, next);
                  }}
                />
              </div>
            </div>
            {/* qRandomDiv：筆數（僅隨機出題，:1351-1357 required min1，decorator.jsp:279 min 訊息「不可小於 1.」）。 */}
            {groupDraft.examType === '2' ? (
              <div className="flex items-start gap-2">
                <label className="w-24 shrink-0 text-sm" htmlFor={`${pageId}-produce-field-random-size`}>
                  <span className="text-danger">*</span>筆數：
                </label>
                <div>
                  <TextInput
                    uiId={`${pageId}-produce-field-random-size`}
                    value={randomSize}
                    onChange={setRandomSize}
                    disabled={busy}
                    invalid={produceErrors.randomSize !== undefined}
                  />
                  {produceErrors.randomSize === undefined ? null : (
                    <div data-ui-id={`${pageId}-produce-error-random-size`} className="text-xs text-danger">
                      {produceErrors.randomSize}
                    </div>
                  )}
                </div>
              </div>
            ) : null}
            {/* qSelectDiv：題目內容（僅從題庫選擇；checkAll＋題型/題目/答案/難易度）。 */}
            {groupDraft.examType === '1' ? (
              <div className="flex items-start gap-2">
                <span className="w-24 shrink-0 text-sm">
                  <span className="text-danger">*</span>題目內容：
                </span>
                <div className="min-w-0 flex-1">
                  <Table
                    uiId={`${pageId}-produce-table`}
                    columns={produceColumns}
                    rows={produceRows.map((question) => ({ ...question }))}
                    rowKey={(tableRow) => String(tableRow['questionId'] ?? '')}
                    renderCell={(tableRow, columnKey) => {
                      const questionId = String(tableRow['questionId'] ?? '');
                      if (columnKey === 'check') {
                        return (
                          <Checkbox
                            uiId={`${pageId}-produce-table-row-${questionId}-check`}
                            checked={produceSelected.has(questionId)}
                            disabled={busy}
                            onChange={(checked) => {
                              const next = new Set(produceSelected);
                              if (checked) {
                                next.add(questionId);
                              } else {
                                next.delete(questionId);
                              }
                              setProduceSelected(next);
                            }}
                          />
                        );
                      }
                      if (columnKey === 'questionType') {
                        return EXAM_QUESTION_TYPE_TEXT[String(tableRow['questionType'] ?? '')] ?? '';
                      }
                      if (columnKey === 'level') {
                        return examDifficultyText(String(tableRow['level'] ?? ''));
                      }
                      return String(tableRow[columnKey] ?? '');
                    }}
                  />
                  {/* checkAll（:195-201；放在表格外圈＝雛形簡化，全選語意照鏡像）。 */}
                  <Checkbox
                    uiId={`${pageId}-produce-field-check-all`}
                    checked={allProduceChecked}
                    label="全選"
                    disabled={busy}
                    onChange={(checked) => {
                      setProduceSelected(
                        checked
                          ? new Set(produceRows.map((question) => question.questionId))
                          : new Set<string>(),
                      );
                    }}
                  />
                </div>
              </div>
            ) : null}
          </div>
        </ModalFrame>
      )}

      {/* ── 自動配分 prompt（common.prompt 鏡像，examManage.jsp:848-896） ── */}
      {autoscoreOpen ? (
        <ModalFrame
          uiId={`${pageId}-autoscore-dialog`}
          open
          title="自動配分"
          size="md"
          onClose={() => {
            setAutoscoreOpen(false);
          }}
          footer={
            <>
              <Button
                uiId={`${pageId}-autoscore-dialog-cancel`}
                variant="default"
                size="sm"
                type="button"
                onClick={() => {
                  setAutoscoreOpen(false);
                }}
              >
                取消
              </Button>
              <Button
                uiId={`${pageId}-autoscore-dialog-ok`}
                variant="primary"
                size="sm"
                type="button"
                onClick={() => {
                  applyAutoscore();
                }}
              >
                確定
              </Button>
            </>
          }
        >
          <div data-ui-id={`${pageId}-autoscore-dialog-body`} className="space-y-3">
            <div className="flex items-start gap-2">
              <label className="shrink-0 text-sm" htmlFor={`${pageId}-autoscore-field-total`}>
                配分總分 :
              </label>
              <div>
                <TextInput
                  uiId={`${pageId}-autoscore-field-total`}
                  value={autoscoreTotal}
                  onChange={setAutoscoreTotal}
                  invalid={autoscoreErrors.total !== undefined}
                />
                {autoscoreErrors.total === undefined ? null : (
                  <div data-ui-id={`${pageId}-autoscore-error-total`} className="text-xs text-danger">
                    {autoscoreErrors.total}
                  </div>
                )}
              </div>
            </div>
            <div className="flex items-start gap-2">
              <span className="shrink-0 text-sm">配分方法 :</span>
              <div className="space-y-1">
                <Radio
                  uiId={`${pageId}-autoscore-field-dist0`}
                  name="distribution"
                  checked={autoscoreDist === '0'}
                  onChange={(checked) => {
                    if (checked) {
                      setAutoscoreDist('0');
                    }
                  }}
                  label=" 整除, 取小數第二位"
                />
                <Radio
                  uiId={`${pageId}-autoscore-field-dist1`}
                  name="distribution"
                  checked={autoscoreDist === '1'}
                  onChange={(checked) => {
                    if (checked) {
                      setAutoscoreDist('1');
                    }
                  }}
                  label=" 整除, 剩餘分數歸屬在第一題(首題)"
                />
                <Radio
                  uiId={`${pageId}-autoscore-field-dist2`}
                  name="distribution"
                  checked={autoscoreDist === '2'}
                  onChange={(checked) => {
                    if (checked) {
                      setAutoscoreDist('2');
                    }
                  }}
                  label=" 整除, 剩餘分數歸屬在最後一題(末題)"
                />
              </div>
            </div>
          </div>
        </ModalFrame>
      ) : null}
    </>
  );
}
